import { CheckIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { Button } from '@/components/ui/button';

/** In place of an Add button, once what it would add is in the Workbook. */
export function AddedButton() {
  return (
    <Button size="sm" variant="outline" disabled>
      <CheckIcon />
      <T context="workbook add data: this data is in the workbook already">
        Added
      </T>
    </Button>
  );
}
